import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteContatoExcelExportModalComponent } from './export-contatos';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteContatoExcelExportModalComponent
    ],
    exports: [
        ClienteContatoExcelExportModalComponent
    ]
})
export class ClienteExcelModule { }
